import script from "./TemplateManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&setup=true&lang=js"

import "./TemplateManagement.vue?vue&type=style&index=0&id=b5d21aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d21aa8"]])

export default __exports__